/* eslint-disable no-case-declarations */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/no-children-prop */
/* eslint-disable react/no-will-update-set-state */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isEqual, find } from 'lodash';
import { Grid, IconButton, Tooltip } from '@mui/material';
import {
  Delete as DeleteIcon,
  Info,
  Edit,
  ChevronRight
} from '@mui/icons-material';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import Table from '../../../TableContainer/Table';
import Dialog from '../../../Dialog/Dialog';
import { getColumnWidths } from '../../../TableContainer/TableUtilities/getColumnWidths';
import { getColumnCompare } from '../../../TableContainer/TableUtilities/columnFormatter';
import { getAffiliates } from '../../requests';
import { getTableData } from '../../../TableContainer/TableUtilities/buildTableRequest';
import {
  renderDefaultCell,
  renderPercentCell
} from '../../../TableContainer/TableUtilities/defaultCells';
import ActionDrawer from '../../../PageContainer/ActionDrawer';
import EditAffiliate from './render/EditAffiliate';
import AffiliateSettings from '../AffiliateSettings';
import PlacementTypesForms from '../PlacementTypesForms';
import AffiliateSetupCheck from '../AffiliateSetupCheck';
import Toggle from '../../../FormContainer/FormComponents/Toggle';
import {
  checkAdmin,
  checkTech,
  checkAffiliateManager,
  checkPowerUser
} from '../../../PermissionsWrappers/permissionChecks';
import { NetworkRequest } from '../../../Utilities/NetworkRequests/NetworkRequests';
import { getTrafficSources } from '../../../common/commonRequests';
import { handleChange as handleFilterChange } from '../../../Filters/actions/actions';
import { saveToLocalStorage } from '../../../Utilities/saveStateHelper';
import { logError } from '../../../../Utilities/logError';
import { ActionItemsContext } from '../../../MainContainer/context/ActionItemsContext';

const columns = [
  { name: 'affiliate_id', title: 'Affiliate ID', compare: 'priority' },
  { name: 'affiliate_name', title: 'Affiliate Name', width: 550 },
  { name: 'is_external', title: 'Is External' },
  { name: 'throttle_percentage', title: 'Throttle Percentage' },
  { name: 'throttle_status', title: 'Throttle Status', compare: 'priority' },
  { name: 'logpixel', title: 'Log Pixels', compare: 'priority' },
  { name: 'traffic_source', title: 'Traffic Source', compare: 'priority' },
  { name: 'actions', title: 'Actions' },
  { name: 'status', title: 'Status' },
  { name: 'traffic_approved', title: 'Traffic Approved' },
  checkAdmin() || checkTech()
    ? { name: 'placement_types', title: 'TY placement types', width: 130 }
    : '',
  { name: 'settings', title: 'Settings' },
  checkAdmin() || checkTech() || checkAffiliateManager() || checkPowerUser()
    ? { name: 'affiliate_setup_check', title: 'Setup' }
    : ''
].filter((column) => !!column);

if (checkAffiliateManager() || checkPowerUser()) {
  columns.splice(2, 1);
}

const buildTableParams = (action, props) => ({
  action,
  type: props.affiliateType
});

export const AFF_DETAILS_ROUTE = '/Setup/affiliate_details/';

class AffiliateList extends Component {
  state = {
    rows: [],
    loading: true,
    deleteResponses: {},
    dialog: {
      message: '',
      affidToRemove: 'none'
    },
    loadingError: false
  };

  requestTime = React.createRef();

  getRequestTime = () => this.requestTime.current.toString();

  UNSAFE_componentWillMount() {
    getTrafficSources().then((value) =>
      this.setState({ trafficSource: value })
    );
  }

  componentWillUnmount() {
    if (
      checkAffiliateManager() ||
      checkTech() ||
      checkAdmin() ||
      checkPowerUser()
    ) {
      this.props.handleFilterChange('affiliateType', 'all');
      saveToLocalStorage('affiliate_listaffiliateType', 'all');
    }
  }

  handleGetTableData = async () => {
    try {
      this.setState({ loading: true });
      return await getTableData(
        buildTableParams('getAffiliates', this.props),
        getAffiliates,
        (values) => this.state.loading && this.setState(values)
      );
    } catch (error) {
      logError(error);
      this.setState({ rows: [], loading: false, loadingError: true });
      throw error;
    }
  };

  componentDidMount() {
    this.props.handleFilterChange('automaticTestingTableSiteID', 2);
    this.requestTime.current = new Date().getTime() / 1000;
    this.context?.changeLinkedFunc?.(this.handleGetTableData);
    this.handleGetTableData();
  }

  UNSAFE_componentWillUpdate(nextProps) {
    if (
      !isEqual(
        buildTableParams('getAffiliates', this.props),
        buildTableParams('getAffiliates', nextProps)
      )
    ) {
      this.setState({ loading: true, loadingError: false }, () => {
        const requestTime = new Date().getTime() / 1000;
        this.requestTime.current = requestTime;
        getTableData(
          buildTableParams('getAffiliates', nextProps),
          getAffiliates,
          (values) => {
            if (requestTime.toString() === this.getRequestTime()) {
              this.setState(values);
            }
          }
        ).catch((error) => {
          logError(error);
          this.setState({ rows: [], loading: false, loadingError: true });
        });
      });
    }
  }

  toggleDialog = (message = '', affidToRemove = 'none') => {
    this.setState({
      dialog: { message, affidToRemove }
    });
  };

  renderConfirmationDialog = () => (
    <Dialog
      title="Confirm Delete"
      children={this.state.dialog.message}
      open={!!this.state.dialog.message}
      onRequestSave={async () => {
        await this.handleDeleteAffiliate(this.state.dialog.affidToRemove);
        this.toggleDialog('');
      }}
      onRequestClose={() => {
        setTimeout(() => this.toggleDialog(), 300);
      }}
      type="confirm"
      saveButtonText="Delete"
    />
  );

  updateRow = (row, name, value) => {
    const { rows } = this.state;
    rows.forEach(({ affiliate_id }, index) => {
      if (row.affiliate_id === affiliate_id) {
        rows[index][name] = value;
      }
    });
    this.setState({ rows });
  };

  removeDataRow = (id) => {
    let { rows } = this.state;
    rows = rows.filter(({ affiliate_id }) => affiliate_id !== id);
    this.setState({ rows });
  };

  handleDeleteAffiliate = async (affiliate_id) => {
    this.setState(({ deleteResponses }) => ({
      deleteResponses: {
        ...deleteResponses,
        [affiliate_id]: {
          processing: true
        }
      }
    }));
    try {
      const { data } = await NetworkRequest('affiliates', {
        action: 'deleteAffiliate',
        id: affiliate_id
      });
      if (data.success) {
        this.handleDeleteResponse(
          'Affiliate was successfully removed.',
          affiliate_id
        );
        this.removeDataRow(affiliate_id);
      } else {
        this.handleDeleteResponse(
          'Affiliate was not successfully removed.',
          affiliate_id
        );
      }
    } catch (e) {
      this.handleDeleteResponse(
        'Affiliate was not successfully removed.',
        affiliate_id
      );
    }
  };

  handleDeleteResponse = (message, id) =>
    this.setState(
      ({ deleteResponses }) => ({
        deleteResponses: {
          ...deleteResponses,
          [id]: {
            processing: false,
            message
          }
        }
      }),
      () => this.removeAffiliateResponseData(id)
    );

  removeAffiliateResponseData = (id) =>
    setTimeout(
      () =>
        this.setState(({ deleteResponses }) => ({
          deleteResponses: {
            ...deleteResponses,
            [id]: null
          }
        })),
      4000
    );

  handleThrottleToggle = async (row, name, value) => {
    this.updateRow(row, name, value);
    const { data } = await NetworkRequest('throttle', {
      action: 'toggleThrottleStatus',
      throttle_status: value,
      id: row.throttle_id,
      site: row.site,
      throttle_percentage: row.throttle_percentage
    });
    if (!data.success) {
      this.updateRow(row, name, !value);
    }
  };

  handleTrafficApprovalToggle = async (row, name, value) => {
    this.updateRow(row, name, value);
    const { data } = await NetworkRequest('affiliates', {
      action: 'toggleTrafficApproved',
      status: value,
      id: row.affiliate_id
    });
    if (!data.success) {
      this.updateRow(row, name, !value);
    }
  };

  handleStatusToggle = async (row, name, value) => {
    this.updateRow(row, name, value);
    const { data } = await NetworkRequest('affiliates', {
      action: 'toggleAffiliateStatus',
      status: value,
      id: row.affiliate_id
    });
    if (!data.success) {
      this.updateRow(row, name, !value);
    }
  };

  renderPlacementTypes = (row) => (
    <ActionDrawer
      fullWidth
      drawerTitle="TY placement types"
      customIcon={<Edit />}
      content={<PlacementTypesForms row={row} onChange={this.updateRow} />}
    />
  );

  renderSettings = (row) => (
    <ActionDrawer
      fullWidth
      drawerTitle="Settings"
      content={<AffiliateSettings row={row} onChange={this.updateRow} />}
    />
  );

  renderAffiliateSetupCheck = (row) => (
    <ActionDrawer
      fullWidth
      drawerTitle="Check"
      content={<AffiliateSetupCheck row={row} />}
    />
  );

  renderToggle = (row, columnName, handleOnChange) => (
    <Toggle
      value={row[columnName] === true || row[columnName].toString() === '1'}
      name={columnName}
      onChange={(name, value) => handleOnChange(row, name, value)}
    />
  );

  renderEditButton = (row) => {
    const { deleteResponses, trafficSource } = this.state;

    return (
      <Grid container alignItems="right">
        <ActionDrawer
          editIconButton
          drawerTitle="Edit Affiliate"
          content={(toggleDrawer) => (
            <EditAffiliate
              row={row}
              options={{ traffic_source: trafficSource }}
              onChange={this.updateRow}
              toggleDrawer={toggleDrawer}
            />
          )}
        />
        <IconButton
          onClick={() =>
            this.toggleDialog(
              `Are you sure do you want to remove affiliate with id ${row.affiliate_id}?`,
              row.affiliate_id
            )
          }
          variant="contained"
          disabled={
            deleteResponses[row.affiliate_id] &&
            deleteResponses[row.affiliate_id].processing
          }
          size="large"
        >
          <DeleteIcon />
        </IconButton>
      </Grid>
    );
  };

  cellComponent = ({ row, column }) => {
    const { trafficSource } = this.state;
    switch (column.name) {
      case 'affiliate_name':
        return checkAdmin() || checkTech()
          ? renderDefaultCell(
              <Tooltip
                title="Click to see the detailed information about this affiliate"
                placement="bottom"
              >
                <Link
                  className="redirectButton"
                  style={{
                    display: 'inline-flex',
                    textDecoration: 'none',
                    alignItems: 'center'
                  }}
                  to={`${AFF_DETAILS_ROUTE}${row.affiliate_id}`}
                  state={{
                    pageName: 'Affiliate List',
                    link: '/Setup/affiliate_list'
                  }}
                >
                  {row.affiliate_name}
                  <ChevronRight style={{ paddingLeft: '5px' }} />
                </Link>
              </Tooltip>
            )
          : renderDefaultCell(row[column.name]);
      case 'throttle_percentage':
        return renderPercentCell(
          row[column.name] === -1 ? 0 : row[column.name]
        );
      case 'is_external':
      case 'logpixel':
        const value = +row[column.name] === 1 ? 'Yes' : 'No';
        return renderDefaultCell(value);
      case 'traffic_source':
        const trafficSourceName =
          find(trafficSource, { value: row[column.name] }) || {};
        return renderDefaultCell(
          +row[column.name] === 0 ? 'N/A' : trafficSourceName.display
        );
      case 'throttle_status':
        return renderDefaultCell(
          row.throttle_id === -1
            ? 'N/A'
            : this.renderToggle(
                row,
                'throttle_status',
                this.handleThrottleToggle
              )
        );
      case 'traffic_approved':
        return renderDefaultCell(
          this.renderToggle(
            row,
            'traffic_approved',
            this.handleTrafficApprovalToggle
          )
        );
      case 'status':
        return renderDefaultCell(
          this.renderToggle(row, 'status', this.handleStatusToggle)
        );
      case 'actions':
        return renderDefaultCell(this.renderEditButton(row));
      case 'placement_types':
        return renderDefaultCell(this.renderPlacementTypes(row));
      case 'settings':
        return renderDefaultCell(this.renderSettings(row));
      case 'affiliate_setup_check':
        return renderDefaultCell(this.renderAffiliateSetupCheck(row));
      default:
        return renderDefaultCell(row[column.name]);
    }
  };

  filterYesNo = (value, filter, row) =>
    (row[filter.columnName] &&
      filter.value.toLowerCase().includes('y') &&
      +row[filter.columnName] === 1) ||
    (row[filter.columnName] &&
      filter.value.toLowerCase().includes('n') &&
      +row[filter.columnName] === 0);

  filterTrafficSource = (value, filter, row) => {
    const filterValue = filter.value.toLowerCase();
    const trafficSource =
      find(this.state.trafficSource, { value: row[filter.columnName] }) || {};
    return trafficSource.display?.toLowerCase().includes(filterValue);
  };

  render() {
    const integratedFilteringColumnExtensions = [
      { columnName: 'is_external', predicate: this.filterYesNo },
      { columnName: 'logpixel', predicate: this.filterYesNo },
      { columnName: 'traffic_source', predicate: this.filterTrafficSource }
    ];

    return (
      <div>
        <div
          style={{
            padding: '.3rem 1rem',
            margin: '.5rem auto',
            position: 'relative',
            display: 'flex'
          }}
        >
          <Info />
          <div style={{ position: 'relative', top: '5px', left: '10px' }}>
            Note: Deactivating an affiliate will allow traffic to continue but
            the affiliate will no longer be in active in the platform. If
            traffic should be rejected and sent to a blank page, toggle Traffic
            Approved off.
          </div>
        </div>
        <Table
          loading={this.state.loading}
          rows={this.state.rows}
          columns={columns}
          cellComponent={this.cellComponent}
          defaultColumnWidths={getColumnWidths(columns)}
          getColumnCompare={getColumnCompare(columns)}
          integratedFilteringColumnExtensions={
            integratedFilteringColumnExtensions
          }
          tableColumnLocalStorageName="affiliate_list"
          drawerTitle="Affiliate List"
          defaultSortingOrder={[
            { columnName: 'affiliate_id', direction: 'desc' }
          ]}
          loadingError={this.state.loadingError}
        />
        {this.renderConfirmationDialog()}
      </div>
    );
  }
}

AffiliateList.contextType = ActionItemsContext;

export default connect(
  (state) => ({
    startDate: state.dateRange.startDate,
    endDate: state.dateRange.endDate,
    dateRange: state.dateRange.dateRange,
    peak: state.dateRange.peak,
    site: state.filters.site,
    affiliateID: state.filters.affiliateID,
    affiliateType: state.filters.affiliateType,
    selectedPage: state.pageReducer.selectedPage
  }),
  (dispatch) =>
    bindActionCreators(
      {
        handleFilterChange
      },
      dispatch
    )
)(AffiliateList);
